<template>
  <div :class="containerClassName">
    <slot name="label" :label="label" :required="required">
      <label v-if="label">{{label}}<span v-if="required"> *</span></label>
    </slot>
    <div class="switch-container" :class="{'disabled': disabled, 'align-right': align === 'right'}" :style="switchContainerStyle">
      <div class="switch" :class="{'small' : small}">
        <input class="switch-input" :id="id" :name="name" type="checkbox" :checked="checked === trueValue" :disabled="disabled" @change="onChange">

        <label class="switch-paddle" :for="id">
          <span class="switch-active" aria-hidden="false">{{labelTrue}}</span>
          <span class="switch-inactive" aria-hidden="true">{{labelFalse}}</span>
        </label>
      </div>
      <label class="switch-label" for="visibility" :class="{'inactive': checked !== trueValue}">
        <span class="switch-active" aria-hidden="false" @click="toggle()" v-if="checked === trueValue">{{labelTrue}}</span>
        <span class="switch-inactive" aria-hidden="true" @click="toggle()" v-if="checked !== trueValue">{{labelFalse}}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheSwitchInput',
  inject: [
    '$validator'
  ],
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    containerClassName: {
      type: String,
      default: 'cell small-12 medium-6'
    },
    switchContainerStyle: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelTrue: {
      type: [String, Boolean, Number],
      default: 'Ja'
    },
    labelFalse: {
      type: [String, Boolean, Number],
      default: 'Nei'
    },
    trueValue: {
      type: [String, Boolean, Number],
      default: true
    },
    falseValue: {
      type: [String, Boolean, Number],
      default: false
    },
    id: {
      type: String,
      default: function () {
        return 'switch-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: ''
    },
    modelValue: {
      default: undefined
    },
    small: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    align: {
      type: String,
      default: ''
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    model: {}
  },
  data () {
    return {
      checked: false
    }
  },
  mounted () {
    // Init checked
    this.checked = this.modelValue === this.trueValue ? this.trueValue : this.falseValue
  },
  methods: {
    onChange (e) {
      if (!e.target.checked) {
        this.checked = this.falseValue
      } else {
        this.checked = this.trueValue
      }

      this.$emit('input', this.checked)
    },
    toggle () {
      if (this.disabled) {
        return
      }

      if (this.checked === this.trueValue) {
        this.checked = this.falseValue
      } else {
        this.checked = this.trueValue
      }

      this.$emit('input', this.checked)
    }
  },
  watch: {
    modelValue (newValue) {
      // If model value is changed from outside
      this.checked = newValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/TheSwitchInput.vue